import { render } from "./AmendPrice.vue?vue&type=template&id=022f5be9"
import script from "./AmendPrice.vue?vue&type=script&lang=js"
export * from "./AmendPrice.vue?vue&type=script&lang=js"

import "./AmendPrice.vue?vue&type=style&index=0&id=022f5be9&lang=scss"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__